import { Link, useLocation } from "react-router-dom";
import { RedactedText } from "@/components/redaction/RedactedText";
import { useStore } from "@/context/StoreContext";
import { SITE } from "@/data/series";

const NAV = [
  { href: "#null-six", label: "Null Six" },
  { href: "#books", label: "The Six" },
  { href: "#status", label: "Schedule" },
  { href: "#waitlist", label: "Signal" }
];

export const SiteHeader = () => {
  const { pathname } = useLocation();
  const { code, kindleUrl } = useStore();
  const onHome = pathname === "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-border bg-[hsl(220_18%_6%/0.82)] backdrop-blur-md"
    >
      <div
        className="control-strip overflow-hidden"
        data-testid="control-strip"
      >
        <div className="mx-auto max-w-6xl px-4 py-1.5 sm:px-6">
          <p className="truncate font-mono text-[9.5px] uppercase tracking-[0.18em] text-[hsl(2_70%_66%)]">
            <RedactedText text={SITE.controlStrip} />
          </p>
        </div>
      </div>

      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link
          to="/"
          data-testid="header-home-link"
          className="flex items-center gap-3"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-[6px] border border-[hsl(174_72%_42%/0.45)] bg-[hsl(174_40%_40%/0.1)] font-mono text-[13px] font-semibold text-[hsl(174_62%_64%)]">
            V
          </span>
          <span className="leading-none">
            <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
              Series dossier
            </span>
            <span className="block text-[13px] font-semibold tracking-tight sm:text-sm">
              {SITE.seriesTitle}
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {onHome &&
            NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="rounded-md px-3 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground transition-colors duration-150 hover:bg-white/5 hover:text-foreground"
              >
                {item.label}
              </a>
            ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/read"
            data-testid="header-read-link"
            className="hidden rounded-[10px] border border-border px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-foreground transition-colors duration-150 hover:border-[hsl(174_72%_42%/0.5)] hover:bg-white/5 sm:inline-flex"
          >
            Read the opening
          </Link>
          <a
            href={kindleUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-buy-link"
            className="rounded-[10px] bg-primary px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-primary-foreground transition-colors duration-150 hover:bg-[hsl(174_72%_36%)]"
          >
            Book One · Kindle{" "}
            <span aria-hidden="true" className="text-primary-foreground/70">
              {code}
            </span>
          </a>
          <a
            href={onHome ? "#waitlist" : "/#waitlist"}
            data-testid="header-join-link"
            className="hidden rounded-[10px] border border-border px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground transition-colors duration-150 hover:border-[hsl(174_72%_42%/0.5)] hover:text-foreground sm:inline-flex"
          >
            Join the signal
          </a>
        </div>
      </div>
    </header>
  );
};
